import { render, staticRenderFns } from "./NotificationAlertList.vue?vue&type=template&id=029e06be&scoped=true&"
import script from "./NotificationAlertList.vue?vue&type=script&lang=js&"
export * from "./NotificationAlertList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlertList.vue?vue&type=style&index=0&id=029e06be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e06be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VProgressCircular,VRow})
